import React from 'react';
import { HolderOutlined } from '@ant-design/icons';
import { useDndContext, useDraggable, useDroppable } from '@dnd-kit/core';

export function AssistantDragGrip({ record }) {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: record.tableKey,
    data: {
      rowKind: record.rowKind,
      assistantId: record.id,
      parentRouterId: record.parentRouterId,
    },
  });
  return (
    <button
      type="button"
      ref={setNodeRef}
      className="assistant-drag-grip"
      aria-label={`Drag ${record.name}`}
      onClick={(event) => event.stopPropagation()}
      {...listeners}
      {...attributes}
    >
      <HolderOutlined />
    </button>
  );
}

export function AssistantRemoveStrip({ routerName }) {
  const { setNodeRef, isOver } = useDroppable({
    id: 'remove-strip',
    data: { dropKind: 'strip' },
  });
  return (
    <div ref={setNodeRef} className={`assistant-remove-strip${isOver ? ' is-over' : ''}`}>
      Drop here to remove from {routerName}
    </div>
  );
}

export function dropLabelFor(record, drag) {
  if (!drag || drag.rowKind === 'router' || record.depth) return '';
  if (record.id === drag.assistantId) return '';
  if (record.rowKind === 'router') return `Under ${record.name}`;
  if (record.rowKind === 'assistant') return `Make ${record.name} a router`;
  return '';
}

export function AssistantDropLabel({ record }) {
  const { active, over } = useDndContext();
  const label = over?.id === `drop-${record.tableKey}`
    ? dropLabelFor(record, active?.data?.current)
    : '';
  if (!label) return null;
  return <span className="assistant-drop-label">{label}</span>;
}

export function AssistantDropRow(props) {
  const { record, className, children, ...rest } = props;
  const { active } = useDndContext();
  const { setNodeRef, isOver } = useDroppable({
    id: `drop-${record?.tableKey || 'missing'}`,
    disabled: !record || record.depth > 0,
    data: {
      dropKind: record?.rowKind,
      assistantId: record?.id,
    },
  });
  const label = record ? dropLabelFor(record, active?.data?.current) : '';
  const overClass = isOver && label ? 'assistant-drop-over' : '';
  return (
    <tr
      ref={setNodeRef}
      {...rest}
      className={[className, overClass].filter(Boolean).join(' ')}
    >
      {children}
    </tr>
  );
}
